import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUp, Facebook, Mail, Phone, MapPin } from 'lucide-react';

function Footer() {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScroll(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <Link to="/" className="nav-logo">
                <div className="nav-logo-icon">PDI</div>
                <span>PDI Care</span>
              </Link>
              <p>
                Providing accessible, high-quality portable diagnostic imaging services
                across Los Angeles. Available 24/7 wherever you need us.
              </p>
            </div>

            <div className="footer-col">
              <h4>Navigation</h4>
              <Link to="/">Home</Link>
              <Link to="/services">Services</Link>
              <Link to="/insurances">Insurance</Link>
              <Link to="/order-exam">Order Exam</Link>
            </div>

            <div className="footer-col">
              <h4>Services</h4>
              <Link to="/services">Mobile X-Ray</Link>
              <Link to="/services">Ultrasound</Link>
              <Link to="/services">EKG / ECG</Link>
            </div>

            <div className="footer-col">
              <h4>Contact</h4>
              <a href="tel:8186265240">
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Phone size={14} /> (818) 626-5240
                </span>
              </a>
              <a href="mailto:exams@pdicare.com">
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Mail size={14} /> exams@pdicare.com
                </span>
              </a>
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                <MapPin size={14} /> Los Angeles, CA
              </span>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Portable Diagnostic Imaging. All rights reserved.</p>
            <a
              href="https://softangeles.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: '14px', opacity: 0.9, fontSize: '15px', fontWeight: 500, textDecoration: 'none', color: '#1e293b' }}
            >
              <span>Powered by</span>
              <img src="https://softangeles.com/logo-wide.png" alt="SoftAngeles" style={{ height: '30px', width: 'auto' }} />
            </a>
            <div className="footer-socials">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Facebook"
              >
                <Facebook />
              </a>
              <a
                href="mailto:exams@pdicare.com"
                className="footer-social-link"
                aria-label="Email"
              >
                <Mail />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <button
        className={`scroll-top ${showScroll ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <ArrowUp />
      </button>
    </>
  );
}

export default Footer;
